"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotSupportedEcosystem = void 0;
class NotSupportedEcosystem extends Error {
    constructor(...args) {
        super(...args);
        this.code = 422;
        this.name = 'NotSupportedEcosystem';
        Error.captureStackTrace(this, NotSupportedEcosystem);
    }
}
exports.NotSupportedEcosystem = NotSupportedEcosystem;
//# sourceMappingURL=not-supported-ecosystem-error.js.map